import React from 'react';

import Select from 'react-select';

import TextButton from 'CommonComponents/TextButton';

import CircleCheckIcon from 'Assets/icons/circle-check.svg';
import CircleCancelIcon from 'Assets/icons/circle-xmark.svg';
import EditIcon from 'Assets/icons/edit.svg';

export default function TrackingCategoriesTableRow(props) {
    const edited = () => {
        return !!props.editedCategory && props.editedCategory.id === props.category.id;
    };

    const getDefaultValue = (id, options) => {
        if (!id) {
            return '';
        }

        let res = '';
        options.forEach((set) => {
            set.options.forEach((item) => {
                if (item.value === id) {
                    res = item;
                }
            });
        });

        return res;
    };

    return (
        <tr>
            <td>{props.category.category_name}</td>
            <td>{props.category.option_name}</td>
            <td>
                {!!edited() && (
                    <Select
                        options={props.departmentOptions}
                        value={getDefaultValue(props.editedCategory.typed_id, props.departmentOptions)}
                        onChange={(e) => props.changeAllocation(props.index, e)}
                        className="react-select-container tw-w-52"
                        classNamePrefix="react-select"
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        styles={{
                            control: (base, state) => ({
                                ...base,
                                minHeight: '32px',
                                height: '32px',
                                fontSize: '12px',
                                borderColor: '#A0A4AB',
                                borderRadius: '6px',
                                boxShadow: state.isFocused ? '0 0 0 1px #A0A4AB' : 'none',
                                '&:hover': {
                                    borderColor: '#6B7280',
                                },
                            }),
                            valueContainer: (base) => ({
                                ...base,
                                height: '32px',
                                padding: '0 8px',
                            }),
                            input: (base) => ({
                                ...base,
                                margin: '0px',
                                fontSize: '12px',
                            }),
                            indicatorsContainer: (base) => ({
                                ...base,
                                height: '32px',
                            }),
                            indicatorSeparator: () => ({
                                display: 'none',
                            }),
                            dropdownIndicator: (base) => ({
                                ...base,
                                padding: '4px',
                                color: '#4B5563',
                                fontSize: '12px',
                                fontWeight: '500',
                            }),
                            singleValue: (base) => ({
                                ...base,
                                fontWeight: '500',
                                color: '#1F2937',
                                fontSize: '12px',
                            }),
                            menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999,
                            }),
                            menuList: (base) => ({
                                ...base,
                                maxHeight: '200px',
                                overflowY: 'auto',
                                fontSize: '12px',
                            }),
                        }}
                    />
                )}
                {!edited() && <span>{props.category.allocation_name || '-'}</span>}
            </td>
            <td>
                <div className="tw-flex tw-justify-start tw-items-center">
                    {!!edited() && (
                        <>
                            <div className="tw-mr-3 tw-cursor-pointer">
                                <TextButton onClick={props.saveCategory} className="tw-flex tw-items-center">
                                    <CircleCheckIcon className="tw-h-3 tw-w-3 tw-text-green-500" />
                                    {$t('Save')}
                                </TextButton>
                            </div>
                            <div className="tw-mr-3 tw-cursor-pointer">
                                <TextButton onClick={props.cancelEdit} className="tw-flex tw-items-center">
                                    <CircleCancelIcon className="tw-h-3 tw-w-3 tw-text-red-500" />
                                    {$t('Cancel')}
                                </TextButton>
                            </div>
                        </>
                    )}
                    {!edited() && (
                        <div className="tw-mr-3 tw-cursor-pointer">
                            <TextButton onClick={(e) => props.editCategory(props.category)} className="tw-flex tw-items-center">
                                <EditIcon className="tw-h-3 tw-w-3" />
                                {$t('Edit')}
                            </TextButton>
                        </div>
                    )}
                </div>
            </td>
        </tr>
    );
}
